import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "index-counter" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "__footer" }
const _hoisted_4 = { class: "company-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      id: "myIframe",
      src: _ctx.url,
      frameborder: "0"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, [
        _cache[2] || (_cache[2] = _createElementVNode("span", null, "地址：北京市海淀区西北旺东路10号院东区7号楼1层W102", -1)),
        _cache[3] || (_cache[3] = _createTextVNode("     ")),
        _cache[4] || (_cache[4] = _createElementVNode("span", null, "电话：010-82826826", -1)),
        _cache[5] || (_cache[5] = _createTextVNode("     ")),
        _cache[6] || (_cache[6] = _createElementVNode("span", null, "应用名：毛豆爱古诗", -1)),
        _cache[7] || (_cache[7] = _createTextVNode("     ")),
        _createElementVNode("span", {
          class: "xieyi",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoxieyi && _ctx.gotoxieyi(...args)))
        }, "用户协议"),
        _cache[8] || (_cache[8] = _createTextVNode("     ")),
        _createElementVNode("span", {
          class: "zhengce",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoyinsi && _ctx.gotoyinsi(...args)))
        }, "隐私政策")
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "company-info" }, [
        _createElementVNode("span", null, " Copyright©2020-2023 feihua100.com . All Rights Reserved . 高途教育科技集团有限公司 "),
        _createTextVNode("     "),
        _createElementVNode("span", null, "11010802039018"),
        _createElementVNode("span", null, "京ICP备14027590号-138")
      ], -1))
    ])
  ]))
}